import LogManager from "./LogManager";

/**
 * Fetches feature flag evaluations from the backend.
 * Automatically appends required context based on flag type.
 *
 * @param {Object} params
 * @param {string[]} [params.allowlist] - Allowlist flag keys (no extra context needed)
 * @param {string[]} [params.percentage] - Percentage flag keys (no extra context needed)
 * @param {string[]} [params.org] - Org flag keys (requires supervisorChain context)
 * @param {string[]} [params.bravehearts] - Bravehearts flag keys (checks bravehearts DDB membership)
 * @returns {Promise<Object|null>} Map of flagKey -> boolean, or null on error
 */
export const fetchFeatureFlags = async ({ allowlist = [], percentage = [], org = [], bravehearts = [] }) => {
  try {
    const flags = {};
    for (const key of allowlist) flags[key] = [];
    for (const key of percentage) flags[key] = [];
    for (const key of org) flags[key] = ["supervisorChain"];
    for (const key of bravehearts) flags[key] = ["bravehearts"];

    if (Object.keys(flags).length === 0) {
      LogManager.warn("fetchFeatureFlags called with no flags");
      return null;
    }

    LogManager.info("Calling /feature-flags. Request body:", JSON.stringify({ flags }));

    const response = await fetch("/feature-flags", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ flags }),
    });

    if (!response.ok) {
      throw new Error(`/feature-flags response failed with status ${response.status}`);
    }

    const responseJson = await response.json();
    LogManager.info("Parsed /feature-flags response:", responseJson);

    const payloadString = JSON.parse(responseJson.Payload);
    const payload = JSON.parse(payloadString);

    return payload;
  } catch (error) {
    LogManager.error("Error calling /feature-flags:", error);
    return null;
  }
};
